import { useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function RenovationSalleDeBains() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Rénovation Salle de Bains Valence | Douche, Sanitaires, Plomberie | Ion Certan';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Rénovation salle de bains à Valence : douche à l\'italienne, pose WC et vasque, carrelage, plomberie complète. Ion Certan, artisan local avec garantie décennale. Devis gratuit à Valence, Bourg-lès-Valence, Guilherand-Granges.');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/services/renovation-salle-de-bains');
    }
    return () => {
      if (metaDesc) {
        metaDesc.setAttribute('content', 'Plombier Chauffagiste et Sanitaire à Valence. Ion Certan, artisan expert en installation climatisation, chauffage, plomberie et rénovation salle de bains. Intervention rapide à Valence, Bourg-lès-Valence, Guilherand-Granges. Devis gratuit. Noté 5,0 sur Google.');
      }
      if (canonical) {
        canonical.setAttribute('href', 'https://plombier-chauffagiste-sanitaire.fr/');
      }
    };
  }, []);

  const avantages = [
    {
      icon: 'ri-pencil-ruler-2-line',
      title: 'Conception sur mesure',
      description: 'Étude personnalisée de votre projet avec plans et conseils adaptés à vos besoins et votre budget'
    },
    {
      icon: 'ri-tools-line',
      title: 'Travaux complets',
      description: 'Plomberie, carrelage, électricité, menuiserie - tous les corps de métier pour une rénovation clé en main'
    },
    {
      icon: 'ri-time-line',
      title: 'Délais respectés',
      description: 'Planning précis et respect des délais annoncés pour minimiser la gêne occasionnée'
    },
    {
      icon: 'ri-star-line',
      title: 'Finitions soignées',
      description: 'Attention particulière portée aux détails et aux finitions pour un résultat impeccable et durable'
    }
  ];

  const etapes = [
    {
      numero: '01',
      titre: 'Visite et diagnostic',
      description: 'Déplacement gratuit à Valence pour évaluer votre salle de bains actuelle et comprendre vos attentes'
    },
    {
      numero: '02',
      titre: 'Devis détaillé',
      description: 'Proposition chiffrée complète avec choix des équipements sanitaires et des matériaux'
    },
    {
      numero: '03',
      titre: 'Démolition et préparation',
      description: 'Retrait des anciens équipements, protection des zones adjacentes, évacuation des gravats'
    },
    {
      numero: '04',
      titre: 'Installation plomberie',
      description: 'Pose des nouvelles canalisations, raccordements eau chaude et froide, évacuations'
    },
    {
      numero: '05',
      titre: 'Pose sanitaires et finitions',
      description: 'Installation douche, WC, vasque, robinetterie, carrelage mural et au sol, joints silicone'
    },
    {
      numero: '06',
      titre: 'Réception et garanties',
      description: 'Vérification du bon fonctionnement, nettoyage complet, remise des garanties fabricants'
    }
  ];

  const faq = [
    {
      question: 'Quel est le délai moyen pour rénover une salle de bains à Valence ?',
      answer: 'La durée dépend de l\'ampleur des travaux. Je vous fournis un planning précis dès l\'acceptation du devis pour que vous puissiez organiser votre quotidien pendant les travaux.'
    },
    {
      question: 'Quels équipements sanitaires proposez-vous pour la rénovation ?',
      answer: 'Je propose une large gamme d\'équipements sanitaires adaptés à tous les budgets : douches à l\'italienne, cabines de douche, baignoires, WC suspendus ou au sol, vasques simples ou doubles, robinetterie design ou classique. Je travaille avec des marques reconnues (Grohe, Hansgrohe, Geberit, Jacob Delafon) et peux vous conseiller sur les meilleurs choix selon vos besoins et votre budget.'
    },
    {
      question: 'Intervenez-vous pour la rénovation de salle de bains à Bourg-lès-Valence ?',
      answer: 'Oui, j\'interviens pour tous vos projets de rénovation de salle de bains à Bourg-lès-Valence, Guilherand-Granges, Portes-lès-Valence et dans toute l\'agglomération valentinoise. Le déplacement pour l\'établissement du devis est gratuit dans un rayon de 20 km autour de Valence.'
    },
    {
      question: 'Faut-il prévoir un budget pour les imprévus lors d\'une rénovation ?',
      answer: 'Il est effectivement prudent de prévoir une marge de 10 à 15% pour les imprévus, notamment dans les logements anciens où l\'on peut découvrir des problèmes cachés (canalisations vétustes, infiltrations, problèmes d\'étanchéité). Lors de mon diagnostic initial, j\'identifie au maximum les risques potentiels pour limiter les surprises.'
    },
    {
      question: 'Proposez-vous des solutions pour les petites salles de bains ?',
      answer: 'Absolument ! Je suis spécialisé dans l\'optimisation des petites salles de bains, très courantes à Valence. Douche à l\'italienne pour gagner de l\'espace, WC suspendus, vasques compactes, rangements muraux intelligents, miroirs agrandissants - je vous propose des solutions astucieuses pour maximiser chaque mètre carré tout en conservant confort et esthétique.'
    },
    {
      question: 'Quelles sont les garanties sur une rénovation de salle de bains ?',
      answer: 'Vous bénéficiez de la garantie décennale sur les travaux de plomberie et d\'étanchéité, de la garantie biennale sur les équipements, et des garanties fabricants sur tous les sanitaires installés. Je vous remets tous les certificats de garantie en fin de chantier.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-20 sm:pt-32 pb-12 sm:pb-20 bg-gradient-to-br from-teal-50 via-white to-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
            <div>
              <div className="inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-teal-100 rounded-full mb-4 sm:mb-6">
                <span className="text-xs sm:text-sm font-semibold text-teal-700">Rénovation Complète</span>
              </div>
              <h1 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                Rénovation de Salle de Bains à Valence
              </h1>
              <p className="text-sm sm:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                Transformez votre salle de bains en un espace moderne, fonctionnel et esthétique. Plombier chauffagiste à Valence, je réalise l'intégralité de vos travaux de rénovation sanitaire avec un soin particulier porté aux finitions.
              </p>
              <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4">
                <a
                  href="tel:+33760705475"
                  className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap text-sm sm:text-base"
                >
                  <i className="ri-phone-line mr-2"></i>
                  07 60 70 54 75
                </a>
                <a
                  href="mailto:ioncertanpro@gmail.com"
                  className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-white border-2 border-gray-300 text-gray-700 font-semibold rounded-lg hover:border-teal-600 hover:text-teal-600 transition-colors whitespace-nowrap text-sm sm:text-base"
                >
                  <i className="ri-mail-line mr-2"></i>
                  Demander un devis
                </a>
              </div>
            </div>
            <div className="relative h-64 sm:h-80 lg:h-full min-h-[300px] sm:min-h-[400px]">
              <img
                src="https://public.readdy.ai/ai/img_res/f751519d0d7f5d71e3360e85245b04e9.jpg"
                alt="Rénovation salle de bains moderne à Valence"
                className="w-full h-full object-cover object-top rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Prestations Section */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Prestations de Rénovation Salle de Bains
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              De la conception à la réalisation, je prends en charge tous les aspects de votre projet de rénovation à Valence et ses environs
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
            {[
              { icon: 'ri-drop-line', color: 'bg-teal-600', bg: 'from-teal-50', border: 'border-teal-100', title: 'Installation Douche', desc: 'Pose de douche à l\'italienne, cabine de douche, receveur extra-plat, paroi vitrée, colonne de douche thermostatique. Étanchéité garantie et finitions impeccables pour votre confort quotidien à Valence.' },
              { icon: 'ri-water-flash-line', color: 'bg-orange-600', bg: 'from-orange-50', border: 'border-orange-100', title: 'Plomberie Sanitaire', desc: 'Remplacement ou création de toutes les canalisations eau chaude et froide, évacuations, raccordements. Travail soigné selon les normes DTU pour une installation durable et sans fuite.' },
              { icon: 'ri-contrast-drop-2-line', color: 'bg-teal-600', bg: 'from-teal-50', border: 'border-teal-100', title: 'Pose WC et Vasque', desc: 'Installation de WC suspendus ou au sol, vasques simples ou doubles, meubles de salle de bains. Raccordement eau et évacuation, fixations murales renforcées, joints silicone professionnels.' },
              { icon: 'ri-paint-brush-line', color: 'bg-orange-600', bg: 'from-orange-50', border: 'border-orange-100', title: 'Carrelage et Faïence', desc: 'Pose de carrelage au sol et faïence murale, mosaïque, galets. Découpes précises, joints réguliers, étanchéité parfaite. Large choix de matériaux et de styles pour personnaliser votre salle de bains.' },
              { icon: 'ri-lightbulb-line', color: 'bg-teal-600', bg: 'from-teal-50', border: 'border-teal-100', title: 'Électricité et Éclairage', desc: 'Installation électrique aux normes NF C 15-100 pour salle de bains : spots LED, appliques murales, prises rasoir, VMC. Respect des volumes de sécurité et protection IP adaptée.' },
              { icon: 'ri-hammer-line', color: 'bg-orange-600', bg: 'from-orange-50', border: 'border-orange-100', title: 'Menuiserie et Finitions', desc: 'Pose de meubles vasque, miroirs, tablettes, porte-serviettes, accessoires. Peinture, enduits, joints silicone. Chaque détail compte pour un résultat final parfait et harmonieux.' },
            ].map((item, i) => (
              <div key={i} className={`bg-gradient-to-br ${item.bg} to-white p-5 sm:p-8 rounded-xl border ${item.border}`}>
                <div className={`w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center ${item.color} rounded-lg mb-3 sm:mb-4`}>
                  <i className={`${item.icon} text-xl sm:text-2xl text-white`}></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{item.title}</h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Avantages Section */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Pourquoi Choisir un Artisan Local pour Votre Rénovation ?
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Auto-entrepreneur basé à Valence, je vous garantis un service personnalisé et des finitions soignées
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8">
            {avantages.map((avantage, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center bg-gradient-to-br from-teal-600 to-teal-700 rounded-xl mx-auto mb-3 sm:mb-4 shadow-lg">
                  <i className={`${avantage.icon} text-xl sm:text-3xl text-white`}></i>
                </div>
                <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-1 sm:mb-2">{avantage.title}</h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{avantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processus Section */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Les Étapes de Votre Rénovation
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
              Un processus clair et structuré pour une rénovation de salle de bains réussie à Valence
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
            {etapes.map((etape, index) => (
              <div key={index} className="relative bg-gradient-to-br from-teal-50 to-white p-6 sm:p-8 rounded-xl border border-teal-100">
                <div className="absolute -top-3 -left-3 sm:-top-4 sm:-left-4 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg shadow-lg">
                  <span className="text-sm sm:text-lg font-bold text-white">{etape.numero}</span>
                </div>
                <h3 className="text-base sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 mt-2">{etape.titre}</h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{etape.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Zone Intervention */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-teal-50 via-white to-orange-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Zones d'Intervention pour Rénovation Salle de Bains
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto mb-6 sm:mb-8">
              Basé à Valence, j'interviens dans toute l'agglomération valentinoise pour vos projets de rénovation sanitaire
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 max-w-5xl mx-auto">
            {['Valence', 'Bourg-lès-Valence', 'Guilherand-Granges', 'Portes-lès-Valence', 'Saint-Péray', 'Soyons', 'Étoile-sur-Rhône', 'Montélier'].map((ville, index) => (
              <div key={index} className="flex items-center justify-center bg-white p-3 sm:p-4 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                <i className="ri-map-pin-line text-teal-600 mr-1.5 sm:mr-2 flex-shrink-0"></i>
                <span className="font-semibold text-gray-800 text-xs sm:text-sm">{ville}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
              Questions Fréquentes sur la Rénovation de Salle de Bains
            </h2>
            <p className="text-base sm:text-lg text-gray-600">
              Toutes les réponses à vos questions sur la rénovation sanitaire à Valence
            </p>
          </div>

          <div className="space-y-4 sm:space-y-6">
            {faq.map((item, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-5 sm:p-8 rounded-xl border border-gray-200">
                <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3 flex items-start">
                  <i className="ri-question-line text-teal-600 mr-2 sm:mr-3 mt-0.5 sm:mt-1 flex-shrink-0 text-base sm:text-base"></i>
                  <span>{item.question}</span>
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed ml-6 sm:ml-8">{item.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-14 sm:py-20 bg-gradient-to-br from-teal-600 to-teal-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 sm:mb-6">
            Prêt à Transformer Votre Salle de Bains ?
          </h2>
          <p className="text-sm sm:text-lg text-teal-50 mb-6 sm:mb-8 leading-relaxed">
            Contactez-moi pour un devis gratuit et personnalisé. Déplacement offert à Valence et alentours.
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 justify-center">
            <a
              href="tel:+33760705475"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors shadow-lg whitespace-nowrap text-sm sm:text-base"
            >
              <i className="ri-phone-line mr-2"></i>
              Appelez le 07 60 70 54 75
            </a>
            <a
              href="mailto:ioncertanpro@gmail.com"
              className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 bg-teal-800 text-white font-semibold rounded-lg hover:bg-teal-900 transition-colors shadow-lg whitespace-nowrap text-sm sm:text-base"
            >
              <i className="ri-mail-line mr-2"></i>
              Demander un devis gratuit
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}